/**
 * Render a section through the Section Rendering API.
 * @param {string} url The page URL, with its query string.
 * @param {string} sectionId The section to render.
 * @param {AbortSignal} [signal] The abort signal.
 * @returns {Promise<HTMLElement>} The section element.
 */
export default async function fetchSection(url, sectionId, signal) {
  const separator = url.includes('?') ? '&' : '?';
  const response = await fetch(`${url}${separator}section_id=${sectionId}`, { signal });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const html = await response.text();

  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(`#shopify-section-${sectionId}`);
}
